import { EquipmentOption } from './types';

export const sortPinnedFirst = (options: EquipmentOption[], pinnedValues: string[]) => {
  if (!pinnedValues.length) return options;

  return [
    ...options.filter((el) => pinnedValues.includes(el.value)),
    ...options.filter((el) => !pinnedValues.includes(el.value)),
  ];
};

export const filterOptions = (options: EquipmentOption[], search: string) => {
  const query = search.trim().toLocaleLowerCase();
  if (!query) return options;

  return options.filter((el) => el.label.toLocaleLowerCase().includes(query));
};
